module.exports = __webpack_public_path__ + "static/logos/circle-check-solid-full-2bbf28889c3d60c7f95a9668f2f7ef44.svg";